<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="12" stroke="black" stroke-width="2" />
    <path
      d="M14.6875 22H11.2891V9.32031H14.6875V22ZM11.0898 6.03906C11.0898 5.53125 11.2578 5.11328 11.5938 4.78516C11.9375 4.45703 12.4023 4.29297 12.9883 4.29297C13.5664 4.29297 14.0273 4.45703 14.3711 4.78516C14.7148 5.11328 14.8867 5.53125 14.8867 6.03906C14.8867 6.55469 14.7109 6.97656 14.3594 7.30469C14.0156 7.63281 13.5586 7.79688 12.9883 7.79688C12.418 7.79688 11.957 7.63281 11.6055 7.30469C11.2617 6.97656 11.0898 6.55469 11.0898 6.03906Z"
      fill="#495057"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconInfo',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    },
  },
};
</script>

<style scoped>
</style>